<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-shopping-bag mr-2" />Daftar Order
            </h5>

            <hr />
            <b-row>
                <b-col xs="12" sm="8" md="6" lg="5" xl="5">
                    <b-form-group label="Nama Penerima">
                        <b-form-input
                            v-model="filter.name"
                            maxlength="50"
                            @keydown.enter="onFilterChanged"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" lg="2">
                    <b-form-group label="Aksi">
                        <b-button
                            :disabled="isBusy"
                            variant="primary"
                            @click="onFilterChanged"
                        >
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-4">
                <b-col sm="12" md="7" lg="11">
                    <div class="d-flex" style="gap: 10px">
                        <b-button
                            v-for="(btn, index) in filterButtons"
                            :key="index"
                            size="sm"
                            :variant="
                                btn.isActive && (btn.id == 1 || btn.id == 3)
                                    ? 'primary'
                                    : !btn.isActive &&
                                      (btn.id == 1 || btn.id == 3)
                                    ? 'outline-primary'
                                    : btn.isActive && btn.id == 2
                                    ? 'warning'
                                    : !btn.isActive && btn.id == 2
                                    ? 'outline-warning'
                                    : btn.isActive &&
                                      (btn.id == 4 || btn.id == 8)
                                    ? 'secondary'
                                    : !btn.isActive &&
                                      (btn.id == 4 || btn.id == 8)
                                    ? 'outline-secondary'
                                    : btn.isActive && btn.id == 5
                                    ? 'success'
                                    : !btn.isActive && btn.id == 5
                                    ? 'outline-success'
                                    : btn.isActive &&
                                      (btn.id == 6 || btn.id == 7)
                                    ? 'danger'
                                    : !btn.isActive &&
                                      (btn.id == 6 || btn.id == 7)
                                    ? 'outline-danger'
                                    : ''
                            "
                            :disabled="isBusy"
                            @click="toggleFilter(index)"
                        >
                            {{ btn.label }}
                        </b-button>
                        <span
                            class="text-primary mt-1 ml-2"
                            style="cursor: pointer"
                            @click="resetFilter()"
                            >Reset</span
                        >
                    </div>
                </b-col>
                <!-- <b-col md="2" lg="2">
                    <div
                        class="d-flex justify-content-end align-bottom mb-3"
                        style="height: 40px; gap: 20px"
                    >
                        <div
                            class="d-flex justify-content-center align-items-center mb-3"
                            style="gap: 10px; height: 40px"
                        >
                            <span>{{
                                isShow
                                    ? "Tidak Tampilkan Semua"
                                    : "Tampilkan Semua"
                            }}</span>
                            <b-form-checkbox
                                class="mt-n1"
                                v-model="isShow"
                                @change="getOrder(currentPage)"
                                switch
                                size="lg"
                            ></b-form-checkbox>
                        </div>

                        <b-button
                            size="md"
                            class="ml-2"
                            variant="success"
                            v-b-tooltip.hover.top
                            v-b-tooltip.no-delay
                            :title="btnTitle"
                            :disabled="isBusy"
                            @click="onRefresh()"
                        >
                            <i
                                class="fa fa-fw fa-refresh"
                                :class="{ 'fa-spin': isSpin && !isFilter }"
                            />
                        </b-button>
                    </div>
                </b-col> -->
            </b-row>
            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive
                class="mb-3"
                id="local-table"
                :current-page="currentPage"
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty> Tidak ada data order. </template>
                <template v-slot:cell(name)="row">
                    <span>{{ row.item.address.name }}</span>
                </template>
                <template v-slot:cell(dateOrder)="row">
                    <span>{{ row.item.dateOrder }}</span>
                    <br />
                    <span
                        class="text-muted"
                        style="font-size: 12px; font-weight: 400"
                        >{{ row.item.timeOrder }}</span
                    >
                </template>
                <template v-slot:cell(courier_company)="row">
                    <span>{{
                        capitalizeFirstLetter(
                            row.item.additionalData.courier_company
                        )
                    }}</span>
                </template>
                <template v-slot:cell(courier_type)="row">
                    <span>{{
                        capitalizeFirstLetter(
                            row.item.additionalData.courier_type
                        )
                    }}</span>
                </template>
                <template v-slot:cell(order_note)="row">
                    <span>{{
                        capitalizeFirstLetter(
                            row.item.additionalData.order_note || "-"
                        )
                    }}</span>
                </template>
                <template v-slot:cell(is_active)="row">
                    <b-badge :variant="statusColor(row.item.status)">{{
                        row.item.status === "2"
                            ? "Menunggu Konfirmasi"
                            : row.item.statusDesc
                    }}</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button
                        size="sm"
                        variant="secondary"
                        v-b-tooltip.hover.top
                        title="Detail"
                        :disabled="isBusy || row.item.status == 1"
                        @click="getDetail(row.item.id)"
                    >
                        <i class="fa fa-info-circle" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer
                :totalRows="pageLength"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
        <b-modal
            id="m-detail"
            size="xl"
            title="Detail Data Order"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-container>
                <div class="info-container">
                    <div>
                        <h5>Data Order</h5>
                        <b-row class="mt-3">
                            <b-col cols="5" style="font-weight: 500">ID</b-col>

                            <b-col cols="6" class="label-input">
                                <p>{{ detail.id }}</p></b-col
                            >
                            <b-col
                                :class="{
                                    'mb-3': detailOrderDate === '',
                                }"
                                cols="5"
                                style="font-weight: 500"
                                >Tanggal Order</b-col
                            >

                            <b-col cols="6" class="label-input">
                                <p>{{ detailOrderDate }}</p></b-col
                            >
                            <b-col
                                :class="{
                                    'mb-3': detailOrderTime === '',
                                }"
                                cols="5"
                                style="font-weight: 500"
                                >Waktu Order</b-col
                            >

                            <b-col cols="6" class="label-input">
                                <p>{{ detailOrderTime }}</p></b-col
                            >
                            <b-col cols="5" style="font-weight: 500"
                                >Total Item</b-col
                            >

                            <b-col cols="6" class="label-input">
                                <p>{{ detail.itemTotal }}</p></b-col
                            >
                            <b-col
                                class="mb-3"
                                cols="5"
                                style="font-weight: 500"
                                >Status</b-col
                            >

                            <b-col class="mb-3 label-input" cols="6">
                                <b-badge
                                    :variant="statusColor(detail.status)"
                                    >{{
                                        detail.status === "2"
                                            ? "Menunggu Konfirmasi"
                                            : detail.statusDesc
                                    }}</b-badge
                                ></b-col
                            >
                            <b-col
                                :class="{
                                    'mb-3':
                                        detail.payment_type === '' ||
                                        detail.payment_type === null,
                                }"
                                cols="5"
                                style="font-weight: 500"
                                >Tipe Pembayaran</b-col
                            >

                            <b-col cols="6" class="label-input">
                                <p>{{ detail.payment_type }}</p></b-col
                            >
                            <b-col
                                :class="{
                                    'mb-3':
                                        detail.tracking_id === '' ||
                                        detail.tracking_id === null,
                                }"
                                cols="5"
                                style="font-weight: 500"
                                >ID Tracking</b-col
                            >

                            <b-col cols="6" class="label-input pr-4">
                                <p style="word-wrap: break-word">
                                    {{ detail.tracking_id || "-" }}
                                </p></b-col
                            ><b-col
                                :class="{
                                    'mb-3': detail.rejectedReason === '',
                                }"
                                cols="5"
                                style="font-weight: 500"
                                >Alasan Penolakan</b-col
                            >

                            <b-col cols="6" class="label-input">
                                <p>{{ detail.rejectedReason || "-" }}</p></b-col
                            >
                        </b-row>
                    </div>
                    <div>
                        <h5>Data Pribadi</h5>
                        <b-row class="mt-3">
                            <b-col cols="4" style="font-weight: 500"
                                >Nama</b-col
                            >

                            <b-col cols="7" class="label-input">
                                <p>{{ detail.address.name }}</p></b-col
                            >
                            <b-col cols="4" style="font-weight: 500"
                                >No HP</b-col
                            >

                            <b-col cols="7" class="label-input"
                                ><p>{{ detail.address.nohp }}</p></b-col
                            >
                            <b-col cols="4" style="font-weight: 500">Di</b-col>

                            <b-col cols="7" class="label-input"
                                ><p>
                                    {{ detail.address.address_label }}
                                </p></b-col
                            >
                            <b-col cols="4" style="font-weight: 500"
                                >Alamat</b-col
                            >

                            <b-col cols="7" class="label-input"
                                ><p>{{ detail.address.alamat }}</p></b-col
                            >
                            <b-col
                                :class="{
                                    'mb-3': detail.address.detailed_area === '',
                                }"
                                cols="4"
                                style="font-weight: 500"
                                >Alamat Detail</b-col
                            >

                            <b-col cols="7" class="label-input"
                                ><p>
                                    {{ detail.address.detailed_area }}
                                </p></b-col
                            >
                            <b-col cols="4" style="font-weight: 500"
                                >Kota</b-col
                            >

                            <b-col cols="7" class="label-input"
                                ><p>{{ detail.address.city }}</p></b-col
                            >
                            <b-col cols="4" style="font-weight: 500"
                                >Kabupaten</b-col
                            >

                            <b-col cols="7" class="label-input"
                                ><p>{{ detail.address.district }}</p></b-col
                            >
                            <b-col cols="4" style="font-weight: 500"
                                >Provinsi</b-col
                            >

                            <b-col cols="7" class="label-input"
                                ><p>{{ detail.address.province }}</p></b-col
                            >
                            <b-col cols="4" style="font-weight: 500"
                                >Kode Pos</b-col
                            >

                            <b-col cols="7" class="label-input"
                                ><p>{{ detail.address.postal_code }}</p></b-col
                            >
                            <b-col cols="4" style="font-weight: 500"
                                >Catatan</b-col
                            >

                            <b-col cols="7" class="label-input"
                                ><p>{{ detail.address.note || "-" }}</p></b-col
                            >
                        </b-row>
                    </div>
                    <div>
                        <h5>Data Tambahan</h5>
                        <b-row class="mt-3">
                            <b-col
                                :class="{
                                    'mb-3':
                                        detail.additionalData
                                            .courier_company === '',
                                }"
                                cols="6"
                                style="font-weight: 500"
                                >Perusahaan Kurir</b-col
                            >

                            <b-col cols="5" class="label-input"
                                ><p>
                                    {{
                                        capitalizeFirstLetter(
                                            detail.additionalData
                                                .courier_company
                                        )
                                    }}
                                </p></b-col
                            >
                            <b-col
                                :class="{
                                    'mb-3':
                                        detail.additionalData.courier_type ===
                                        '',
                                }"
                                cols="6"
                                style="font-weight: 500"
                                >Tipe Kurir</b-col
                            >

                            <b-col cols="5" class="label-input"
                                ><p>
                                    {{
                                        capitalizeFirstLetter(
                                            detail.additionalData.courier_type
                                        )
                                    }}
                                </p></b-col
                            >
                            <b-col
                                :class="{
                                    'mb-3':
                                        detail.additionalData.order_note === '',
                                }"
                                cols="6"
                                style="font-weight: 500"
                                >Catatan Order</b-col
                            >

                            <b-col cols="5" class="label-input"
                                ><p>
                                    {{
                                        capitalizeFirstLetter(
                                            detail.additionalData.order_note ||
                                                "-"
                                        )
                                    }}
                                </p></b-col
                            >
                            <b-col cols="6" style="font-weight: 500"
                                >Total Berat</b-col
                            >

                            <b-col cols="5" class="label-input"
                                ><p>
                                    {{ detail.totalWeight + " gram" }}
                                </p></b-col
                            >
                            <b-col cols="6" style="font-weight: 500"
                                >Jumlah Harga Barang</b-col
                            >

                            <b-col cols="5" class="label-input">
                                <p>
                                    {{ "Rp " + formattedCurrency(totalPrice) }}
                                </p></b-col
                            >
                            <!-- <b-col cols="6" style="font-weight: 500">{{
                                detail.asuransiData.name || "Biaya Asuransi"
                            }}</b-col>

                            <b-col cols="5" class="label-input">
                                <p>
                                    {{
                                        "Rp " +
                                        formattedCurrency(
                                            detail.asuransiData.price
                                        )
                                    }}
                                </p></b-col
                            > -->
                            <b-col cols="6" style="font-weight: 500"
                                >Asuransi Pengiriman</b-col
                            >

                            <b-col cols="5" class="label-input">
                                <p>
                                    {{
                                        "Rp " +
                                        formattedCurrency(
                                            detail.asuransiShipment
                                        )
                                    }}
                                </p></b-col
                            >
                            <!-- <b-col cols="6" style="font-weight: 500">{{
                                detail.shippingData.name
                            }}</b-col>

                            <b-col cols="5" class="label-input">
                                <p>
                                    {{
                                        "Rp " +
                                        formattedCurrency(
                                            detail.shippingData.price
                                        )
                                    }}
                                </p></b-col
                            > -->
                            <b-col cols="6" class="mt-2"
                                ><strong>Total</strong></b-col
                            >

                            <b-col cols="5" class="label-input mt-2">
                                <p>
                                    <strong>{{
                                        "Rp " + formattedCurrency(totalAll)
                                    }}</strong>
                                </p></b-col
                            >
                        </b-row>
                        <!-- <b-row
                            v-if="
                                detail.status === '4' ||
                                detail.status === '3' ||
                                detail.status === '2'
                            "
                        >
                            <b-col cols="12">
                                <label for="shipping-date"
                                    >Pilih Tanggal Pengiriman</label
                                >
                            </b-col>
                            <b-col cols="12">
                                <b-form-datepicker
                                    id="shipping-date"
                                    v-model="shippingDate"
                                    :min="minDate"
                                    :disabled="
                                        detail.status === '3' ||
                                        detail.status === '4'
                                    "
                                    class="mb-2"
                                    locale="id"
                                    :date-format-options="{
                                        year: 'numeric',
                                        month: 'numeric',
                                        day: 'numeric',
                                    }"
                                    :state="isDateValid"
                                ></b-form-datepicker>
                            </b-col>
                            <b-col cols="12">
                                <label for="shipping-time"
                                    >Pilih Waktu Pengiriman</label
                                >
                            </b-col>
                            <b-col cols="12">
                                <b-form-timepicker
                                    id="shipping-time"
                                    v-model="shippingTime"
                                    :disabled="
                                        detail.status === '3' ||
                                        detail.status === '4'
                                    "
                                    :formatter="timeFormatter"
                                    locale="id"
                                    class="mb-2"
                                    :state="isTimeValid"
                                ></b-form-timepicker>
                            </b-col>
                        </b-row> -->
                    </div>
                </div>
                <h5>Daftar Item</h5>
                <b-table
                    bordered
                    hover
                    show-empty
                    :busy="isBusy"
                    :items="detail.itemList"
                    :fields="detailHeader"
                    responsive
                    class="mb-3"
                    id="detail-table"
                    :current-page="currentPageDetail"
                    :per-page="perPageDetail"
                    :sort-desc="true"
                >
                    <template v-slot:empty>
                        Tidak ada data item order.
                    </template>
                    <template v-slot:cell(name)="row">
                        <div class="d-flex flex-column">
                            <p>
                                {{
                                    `${row.item.name} ${
                                        row.item.color
                                            ? "(" + row.item.color + ")"
                                            : ""
                                    }`
                                }}
                            </p>
                            <small class="text-muted mt-n3"
                                >{{ row.item.kind }} -
                                {{ row.item.brand }}</small
                            >
                        </div>
                    </template>
                    <template v-slot:cell(no_faktur)="row">
                        <span>{{
                            row.item.no_faktur[0].nofak ||
                            row.item.no_faktur[0] ||
                            ""
                        }}</span>
                    </template>
                    <template v-slot:cell(retail_price)="row">
                        <span>{{
                            "Rp " +
                            $helper.formatThousand(row.item.retail_price)
                        }}</span>
                    </template>
                    <template v-slot:cell(wholesale_price)="row">
                        <span>{{
                            "Rp " +
                            $helper.formatThousand(row.item.wholesale_price)
                        }}</span>
                    </template>
                    <template v-slot:cell(quantity)="row">
                        <span>{{ row.item.quantity + " item" }}</span>
                    </template>
                    <template v-slot:cell(price)="row">
                        <span>{{
                            "Rp " + $helper.formatThousand(row.item.price)
                        }}</span>
                    </template>
                    <template v-slot:cell(grade)="row">
                        <span>{{ row.item.grade }}</span>
                    </template>
                    <template v-slot:cell(spec)="row">
                        <span>{{ row.item.spec }}</span>
                    </template>
                    <template v-slot:cell(kind)="row">
                        <span>{{ row.item.kind }}</span>
                    </template>
                </b-table>
                <b-pagination
                    v-model="currentPageDetail"
                    :total-rows="detail.itemList.length"
                    :per-page="perPageDetail"
                    aria-controls="detail-table"
                    align="right"
                    class="mb-0"
                ></b-pagination>
            </b-container>

            <div class="mt-4 text-right">
                <b-button
                    v-if="detail.status === '2'"
                    variant="primary"
                    :disabled="isSubmitting"
                    @click="approveOrder"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Konfirmasi Pesanan" }}
                </b-button>
                <b-button
                    v-else-if="detail.status === '3'"
                    variant="primary"
                    :disabled="isSubmitting"
                    @click="approveOrder"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Kirim Pesanan" }}
                </b-button>
                <b-button variant="primary" v-else @click="close()">
                    Kembali
                </b-button>
                <b-button
                    v-if="detail.status !== '5' && detail.status !== '4' && detail.status !== '6' && detail.status !== '7' && detail.status !== '8'"
                    variant="danger"
                    class="ml-2"
                    :disabled="isSubmitting"
                    @click="cancelOrder"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Cancel Pesanan" }}
                </b-button>
                <b-button
                    v-if="detail.status !== '2' && detail.status !== '6' && detail.status !== '7' && detail.status !== '8'"
                    variant="secondary"
                    class="ml-2"
                    title="Print Invoice"
                    :disabled="isSubmitting"
                    @click="printInvoice"
                >
                    <i class="fa fa-solid fa-print" />
                </b-button>
            </div>
        </b-modal>
        <b-modal
            id="m-invoice"
            size="xl"
            title="Invoice Data Order"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-container>
                <iframe
                    frameBorder="none"
                    :srcdoc="invoiceData"
                    width="100%"
                    height="300"
                />
            </b-container>
        </b-modal>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data() {
        return {
            initStatus: 0,
            isFilter: false,
            isShow: false,
            isBusy: true,
            isSubmitting: false,
            isSpin: false,
            btnTitle: "Refresh Data",

            // shippingDate: "",

            filterButtons: [
                { id: 1, label: "Menunggu Pembayaran", isActive: false },
                { id: 2, label: "Menunggu Konfirmasi", isActive: false },
                { id: 3, label: "Pengemasan", isActive: false },
                { id: 4, label: "Pengiriman", isActive: false },
                { id: 5, label: "Selesai", isActive: false },
                { id: 6, label: "Dibatalkan", isActive: false },
                { id: 7, label: "Ditolak", isActive: false },
                { id: 8, label: "Expired", isActive: false },
            ],
            activeFilters: [],
            finalFilters: [],
            // initShippingDate: "",
            // minDate: new Date(),
            // shippingTime: "",
            // initShippingTime: "",

            filter: {
                name: "",
                all: false,
                ongoing: false,
                success: false,
                failed: false,
            },

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" },
            ],

            fields: [
                { key: "name", label: "Nama Penerima", sortable: true },
                { key: "dateOrder", label: "Tanggal Order", sortable: true },
                {
                    key: "courier_company",
                    label: "Perusahaan Kurir",
                    sortable: true,
                },
                { key: "courier_type", label: "Tipe Kurir", sortable: true },
                { key: "order_note", label: "Catatan Order", sortable: true },
                { key: "is_active", label: "Status", sortable: true },
                { key: "action", label: "Aksi", sortable: false },
            ],

            detailHeader: [
                { key: "name", label: "Nama", sortable: true },
                { key: "no_faktur", label: "No. Faktur", sortable: true },
                {
                    key: "wholesale_price",
                    label: "Harga Grosir",
                    sortable: true,
                },
                { key: "retail_price", label: "Harga Retail", sortable: true },
                { key: "quantity", label: "Quantity", sortable: true },
                { key: "price", label: "Harga Total", sortable: true },
                { key: "grade", label: "Grade", sortable: true },
                { key: "spec", label: "Spec", sortable: true },
                { key: "kind", label: "Kind", sortable: true },
            ],
            detailOrderDate: "",
            detailOrderTime: "",
            detail: {
                additionalData: {
                    courier_company: "",
                    courier_type: "",
                    destination_cash_on_delivery: false,
                    destination_cash_on_delivery_type: false,
                    destination_cash_proof_of_delivery: false,
                    order_note: "",
                },
                address: {
                    address_label: "",
                    alamat: "",
                    city: "",
                    detailed_area: "",
                    district: "",
                    latitude: 0,
                    longitude: 0,
                    name: "",
                    nohp: "",
                    note: "",
                    postal_code: "",
                    province: "",
                },
                asuransiData: {
                    id: "",
                    name: "",
                    price: 0,
                    quantity: 0,
                },
                asuransiShipment: null,
                shippingData: {
                    id: "",
                    name: "",
                    price: 0,
                    quantity: 1,
                },
                itemList: [],
                orderStatusTime: [],
                id: 0,
                itemTotal: 0,
                payment_type: null,
                rejectedReason: "",
                status: "",
                totalWeight: 0,
                statusDesc: "",
                tracking_id: null,
            },
            invoiceData: [],

            items: [],
            filteredItems: [],

            totalPrice: 0,
            totalAll: 0,

            currentPage: 1,
            pageLength: 0,
            perPage: 10,

            currentPageDetail: 1,
            pageLengthDetail: 0,
            perPageDetail: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: true,
        };
    },

    // computed: {
    //     isDateValid() {
    //         if (
    //             this.shippingDate === "" ||
    //             this.shippingDate === this.initShippingDate
    //         ) {
    //             return null;
    //         } else if (this.shippingDate.length >= 8) {
    //             return true;
    //         } else {
    //             return false;
    //         }
    //     },
    //     isTimeValid() {
    //         if (
    //             this.shippingTime === "" ||
    //             this.shippingTime === this.initShippingTime
    //         ) {
    //             return null;
    //         } else if (this.shippingTime.length >= 5) {
    //             return true;
    //         } else {
    //             return false;
    //         }
    //     },
    // },

    methods: {
        // changeTime(time) {
        //     return time.split(":").slice(0, 2).join(".");
        // },
        timeFormatter(value) {
            return moment(value).format("HH:mm");
        },

        formattedCurrency(val) {
            return val
                ? val.toLocaleString("de-DE", { minimumFractionDigits: 0 })
                : "0,00";
        },

        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        close() {
            this.$bvModal.hide("m-detail");
        },
        init() {
            this.initStatus = 0;
            let getOrder = this.getOrder();

            // const now = new Date();
            // const future = new Date();
            // future.setHours(now.getHours());
            // future.setMinutes(now.getMinutes() + 6);
            // future.setSeconds(now.getSeconds());

            // this.shippingDate = new Date();
            // this.shippingTime = future.toLocaleTimeString("en-US", {
            //     hour12: false,
            // });
            // console.log(this.shippingTime);

            Promise.all([getOrder])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch((_) => {
                    this.initStatus = -1;
                });
        },

        statusColor(status) {
            if (status === "1") {
                return "primary";
            } else if (status === "2") {
                return "warning";
            } else if (status === "3") {
                return "primary";
            } else if (status === "5") {
                return "success";
            } else if (status === "6" || status === "7") {
                return "danger";
            } else {
                return "secondary";
            }
        },

        getDetail(id) {
            this.isBusy = true;
            return this.$axios
                .post(`admin/getDetailOrder?id=${id}`)
                .then((res) => {
                    const data = res.data.data;
                    if (data === undefined) {
                        this.$helper.toastError(this, "Data Kosong!");
                    }

                    this.detail = {
                        ...data,
                        additionalData:
                            data.additionalData !== null
                                ? {
                                      courier_company:
                                          data.additionalData.courier_company,
                                      courier_type:
                                          data.additionalData.courier_type,
                                      destination_cash_on_delivery:
                                          data.additionalData
                                              .destination_cash_on_delivery,
                                      destination_cash_on_delivery_type:
                                          data.additionalData
                                              .destination_cash_on_delivery_type,
                                      destination_cash_proof_of_delivery:
                                          data.additionalData
                                              .destination_cash_proof_of_delivery,
                                      order_note:
                                          data.additionalData.order_note || "",
                                  }
                                : {
                                      courier_company: "",
                                      courier_type: "",
                                      destination_cash_on_delivery: false,
                                      destination_cash_on_delivery_type: false,
                                      destination_cash_proof_of_delivery: false,
                                      order_note: "",
                                  },
                        asuransiData:
                            data.asuransiData === null
                                ? {
                                      id: "",
                                      name: "",
                                      price: 0,
                                      quantity: 0,
                                  }
                                : data.asuransiData,
                        asuransiShipment: data.asuransi_pengiriman || null,
                        itemList: data.itemList.map((i) => {
                            return {
                                ...i,
                                no_faktur: i.no_faktur ? i.no_faktur : "",
                                price: i.final_price || i.price,
                            };
                        }),
                    };

                    this.detailOrderDate =
                        this.detail.orderStatusTime[1].date !== null
                            ? moment(
                                  this.detail.orderStatusTime[1].date.split(
                                      " "
                                  )[0]
                              )
                                  .locale("id")
                                  .format("DD MMMM YYYY")
                            : "";
                    (this.detailOrderTime =
                        this.detail.orderStatusTime[1].date !== null
                            ? this.detail.orderStatusTime[1].date.split(" ")[1]
                            : ""),
                        (this.totalPrice = this.detail.itemList.reduce(
                            (a, b) => a + b.price,
                            0
                        ));
                    this.totalAll =
                        this.totalPrice +
                        this.detail.shippingData.price +
                        this.detail.asuransiData.price;
                    this.$bvModal.show("m-detail");
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        printInvoice() {
            let payload = {
                orderId: this.detail.order_id,
            };

            this.isSubmitting = true;

            this.$axios
                .post("user/printInvoice", payload)
                .then((response) => {
                    // this.$helper.toastSuccess(
                    //     this,
                    //     `Data Order berhasil dibatalkan!`
                    // );
                    this.$bvModal.show("m-invoice");
                    this.invoiceData = response.data;
                    // this.getOrder(this.currentPage);
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => (this.isSubmitting = false));
        },

        cancelOrder() {
            let isConfirmed = confirm(
                "Apakah anda yakin ingin membatalkan order?"
            );
            if (!isConfirmed) return;
            this.isSubmitting = true;

            this.$axios
                .post(`cancelOrder/${this.detail.id}`)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        `Data Order berhasil dibatalkan!`
                    );
                    this.$bvModal.hide("m-detail");
                    this.getOrder(this.currentPage);
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => (this.isSubmitting = false));
        },

        approveOrder() {
            let success = this.detail.status === "2" ? "konfirmasi" : "kirim";
            let action = this.detail.status === "2" ? "onfirmasi" : "irim";
            let isConfirmed = confirm(
                "Apakah anda yakin ingin meng" + action + "kan Data Order?"
            );
            if (!isConfirmed) return;
            // let submitDate = "";
            // if (typeof this.shippingDate === "object") {
            //     const year = this.shippingDate.getFullYear();
            //     const month = String(this.shippingDate.getMonth() + 1).padStart(
            //         2,
            //         "0"
            //     );
            //     const day = String(this.shippingDate.getDate()).padStart(
            //         2,
            //         "0"
            //     );
            //     submitDate = `${year}-${month}-${day}`;
            // } else {
            //     submitDate = this.shippingDate;
            // }

            // const submitTime = this.shippingTime;

            // let now = new Date();
            // let datepicker = new Date(submitDate);
            // let timepicker = new Date(submitDate + "T" + submitTime);
            // let minTime = new Date(now.getTime() + 5 * 60000);

            // if (
            //     datepicker.getDate() <= now.getDate() &&
            //     timepicker.getTime() < minTime.getTime()
            // ) {
            //     this.$helper.toastError(
            //         this,
            //         "Waktu minimal yang diizinkan adalah " +
            //             minTime.toLocaleTimeString("id-ID", { hour12: false })
            //     );
            // }
            //  else if (
            //     datepicker.getDate() === now.getDate() &&
            //     timepicker.getTime() >= minTime.getTime()
            // ) {
            // else {
            let payload = {
                id: this.detail.id,
                status:
                    this.detail.status === "2"
                        ? "3"
                        : this.detail.status === "3"
                        ? "4"
                        : "",
                // shippingDate: submitDate,
                // shippingTime: submitTime.split(":").slice(0, 2).join(":"),
            };

            this.isSubmitting = true;

            this.$axios
                .post("admin/updateOrder", payload)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        `Data Order berhasil di${success}!`
                    );
                    this.$bvModal.hide("m-detail");
                    this.getOrder(this.currentPage);
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => (this.isSubmitting = false));
            // }
        },
        resetFilter() {
            this.filterButtons.forEach((button) => {
                button.isActive = false;
            });
            this.activeFilters = [];
            this.finalFilters = [];
            // console.log(this.activeFilters);
            this.getOrder();
        },

        toggleFilter(index) {
            const button = this.filterButtons[index];
            button.isActive = !button.isActive;

            if (button.isActive) {
                this.activeFilters.push(index + 1);
            } else {
                const filterIndex = this.activeFilters.indexOf(index + 1);
                if (filterIndex !== -1) {
                    this.activeFilters.splice(filterIndex, 1);
                }
            }

            this.finalFilters = JSON.stringify(this.activeFilters);
            console.log(this.finalFilters);
            this.getOrder();
        },

        getOrder(page = 1) {
            this.isBusy = true;

            this.items = [];
            this.btnTitle = "";

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let finalFilter = null;

            if (this.finalFilters == undefined || null || this.finalFilters == '[]') {
                finalFilter = "";
            } else {
                finalFilter = this.finalFilters;
            }
            // console.log(finalFilter);

            // if (this.filter.all == true) {
            //     selectedFilter = "";
            // } else if (
            //     this.filter.ongoing == true &&
            //     this.filter.success == false &&
            //     this.filter.failed == false
            // ) {
            //     selectedFilter = "[1, 2, 3, 4]";
            // } else if (
            //     this.filter.ongoing == false &&
            //     this.filter.success == true &&
            //     this.filter.failed == false
            // ) {
            //     selectedFilter = "[5]";
            // } else if (
            //     this.filter.ongoing == false &&
            //     this.filter.success == false &&
            //     this.filter.failed == true
            // ) {
            //     selectedFilter = "[6, 7, 8]";
            // } else if (
            //     this.filter.ongoing == true &&
            //     this.filter.success == true &&
            //     this.filter.failed == false
            // ) {
            //     selectedFilter = "[1, 2, 3, 4, 5]";
            // } else if (
            //     this.filter.ongoing == false &&
            //     this.filter.success == true &&
            //     this.filter.failed == true
            // ) {
            //     selectedFilter = "[5, 6, 7, 8]";
            // } else if (
            //     this.filter.ongoing == true &&
            //     this.filter.success == false &&
            //     this.filter.failed == true
            // ) {
            //     selectedFilter = "[1, 2, 3, 4, 6, 7, 8]";
            // } else if (
            //     this.filter.ongoing == true &&
            //     this.filter.success == true &&
            //     this.filter.failed == true
            // ) {
            //     selectedFilter = "[1, 2, 3, 4, 5, 6, 7, 8]";
            // } else {
            //     selectedFilter = "";
            // }

            const payload = {
                page: this.currentPage,
                perPage: this.perPage,
                name: this.filter.name || "",
                sortBy: this.sortBy || "id",
                sortDesc: this.sortDesc !== null ? this.sortDesc : "false",
                sortStatus: finalFilter,
            };

            return (
                this.$axios
                    .get(
                        `admin/getOrderUnfiltered?page=${
                            payload.page
                        }&perPage=${payload.perPage}&name=${
                            payload.name
                        }&sortBy=${
                            payload.sortBy === "dateOrder"
                                ? "id"
                                : payload.sortBy === "is_active"
                                ? "status"
                                : payload.sortBy
                        }&sortDesc=${payload.sortDesc}
                        &sortStatus=${finalFilter}`
                    )
                    // .post(`admin/getOrderUnfiltered`, payload)
                    .then((res) => {
                        const data = res.data.data;
                        this.pageLength = data.total;
                        const filteredItem = data.items.map((item) => {
                            return {
                                ...item,
                                additionalData:
                                    item.additionalData !== null
                                        ? {
                                              courier_company:
                                                  item.additionalData
                                                      .courier_company,
                                              courier_type:
                                                  item.additionalData
                                                      .courier_type,
                                              destination_cash_on_delivery:
                                                  item.additionalData
                                                      .destination_cash_on_delivery,
                                              destination_cash_on_delivery_type:
                                                  item.additionalData
                                                      .destination_cash_on_delivery_type,
                                              destination_cash_proof_of_delivery:
                                                  item.additionalData
                                                      .destination_cash_proof_of_delivery,
                                              order_note:
                                                  item.additionalData
                                                      .order_note || "",
                                              //   shippingDate:
                                              //       item.additionalData.shippingDate,
                                              //   shippingTime:
                                              //       item.additionalData.shippingTime,
                                          }
                                        : {
                                              courier_company: "",
                                              courier_type: "",
                                              destination_cash_on_delivery: false,
                                              destination_cash_on_delivery_type: false,
                                              destination_cash_proof_of_delivery: false,
                                              order_note: "",
                                              //   shippingDate: "",
                                              //   shippingTime: "",
                                          },
                                dateOrder:
                                    item.status == "8"
                                        ? moment(
                                              item.orderStatusTime[0].date.split(
                                                  " "
                                              )[0]
                                          )
                                              .locale("id")
                                              .format("DD MMMM YYYY")
                                        : item.status != "8"
                                        ? item.orderStatusTime
                                              .filter(
                                                  (i) => i.status == item.status
                                              )
                                              .map((item) =>
                                                  moment(
                                                      item.date.split(" ")[0]
                                                  )
                                                      .locale("id")
                                                      .format("DD MMMM YYYY")
                                              )[0]
                                        : "",
                                timeOrder:
                                    item.status == "8"
                                        ? item.orderStatusTime[0].date.split(
                                              " "
                                          )[1]
                                        : item.status != "8"
                                        ? item.orderStatusTime
                                              .filter(
                                                  (i) => i.status == item.status
                                              )
                                              .map(
                                                  (item) =>
                                                      item.date.split(" ")[1]
                                              )[0]
                                        : "",
                            };
                        });
                        this.items = filteredItem;
                        this.filteredItems = filteredItem;
                    })
                    .catch((error) => {
                        console.log(error);
                        // this.pageLength = 1;
                        this.$helper.parseError(this, error);
                    })
                    .finally(() => {
                        this.isBusy = false;
                        this.isSpin = false;
                        this.btnTitle = "Refresh Data";
                    })
            );
            // }
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getOrder(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getOrder(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getOrder();
        },

        onRefresh() {
            this.isFilter = false;
            this.isSpin = true;
            this.getOrder();
        },

        onFilterChanged() {
            this.isFilter = true;
            this.isSpin = false;
            this.getOrder();
        },
    },

    created() {
        this.init();
    },
};
</script>

<style scoped>
.info-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
}

.label-input::before {
    position: absolute;
    top: 0;
    left: 0;
    content: ":";
}

@media (max-width: 990px) {
    .info-container {
        grid-template-columns: 1fr 1fr;
        grid-gap: 10px;
    }
}

@media (max-width: 500px) {
    .info-container {
        grid-template-columns: 1fr;
    }
}
</style>
